/**
 * Every task, across every project.
 *
 * The page is a header and the shared `TasksTable` — the same component the
 * project detail uses with its project fixed. One table, two places.
 */

import { PageHeader } from '@connect/web-shared';

import { TasksTable } from './tasks-table';

export function TasksPage() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="Tasks"
        description="Everything outstanding, whoever it belongs to."
      />
      <TasksTable stateKey="tasks.all" />
    </div>
  );
}
